module.exports = __webpack_public_path__ + "static/media/carrossel1.9f7dea4c.jpg";